module.exports = __webpack_public_path__ + "static/edit-banner-for-shipping-date-notification-f91340f43aafcc52be1f27b86eb3b682.png";